var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-dialogue-parent"},[_c('InteractiveDialogue',{attrs:{"dialogue":_vm.dialogue,"videoOptions":_vm.videoOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }